import { use } from 'react';
import { useTranslation } from 'react-i18next';

import WanderingBoundaryPassage from 'features/wandering-boundary-settings/domain/models/wandering-boundary-passage';
import WanderingBoundarySettingsProviderContext from 'features/wandering-boundary-settings/providers/contexts/wandering-boundary-provider-context';

interface WanderingBoundaryPassageRowValidationHookProps {
  wanderingBoundaryPassage: WanderingBoundaryPassage;
  validationRules: {
    name: {
      required: string;
      validate: (value: string) => boolean | string;
    };
    wanderingBoundaryId: {
      required: string;
    };
    detectionLoopDeviceId: {
      required: string;
    };
  };
}

const useWanderingBoundaryPassageRowValidation = (
  wanderingBoundaryPassage: WanderingBoundaryPassage,
): WanderingBoundaryPassageRowValidationHookProps => {
  const { t } = useTranslation('wanderingBoundarySettings');
  const { wanderingBoundaryPassages } = use(WanderingBoundarySettingsProviderContext).detailsState;

  const validationRules = {
    name: {
      required: t('wanderingBoundaryPassageValidationRules.nameRequired'),
      validate: (value: string): boolean | string => {
        const existingPassage = wanderingBoundaryPassages?.find(
          (passage) => passage.name === value && passage.id !== wanderingBoundaryPassage.id,
        );
        return !existingPassage || t('wanderingBoundaryPassageValidationRules.nameNotUnique');
      },
    },
    wanderingBoundaryId: {
      required: t('wanderingBoundaryPassageValidationRules.wanderingBoundaryRequired'),
    },
    detectionLoopDeviceId: {
      required: t('wanderingBoundaryPassageValidationRules.deviceRequired'),
    },
  };

  return {
    wanderingBoundaryPassage,
    validationRules,
  };
};

export default useWanderingBoundaryPassageRowValidation;
